import styled from "styled-components";

export const SPricingCardFeatures = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
